/**
 * SSO session cookie contract.
 *
 * The Identity-Service sets this httpOnly cookie. Sibling apps on the same
 * registrable domain (see `TOP_LVL_DOMAIN`) can read it server-side
 * (e.g. Next.js `cookies().get(SESSION_COOKIE_NAME)`) and call the service
 * with `Authorization: Bearer <value>`. Browser JavaScript cannot read it.
 *
 * `maxAge` for Express is milliseconds (`SESSION_TTL_SECONDS * 1000`);
 * Next.js `cookies().set` uses seconds (`SESSION_TTL_SECONDS`).
 */

/** Idle / absolute cookie lifetime; Redis sliding TTL uses the same default. */
export const SESSION_TTL_SECONDS = 60 * 60 * 24 * 7;

export const SESSION_COOKIE_NAME = "tid" as const;

export const CSRF_COOKIE_NAME = "csrf" as const;

export const SESSION_COOKIE_PATH = "/" as const;

export const SESSION_COOKIE_SAME_SITE = "lax" as const;

/**
 * Cookie flags that are identical across runtimes. `secure` and `domain` stay
 * environment-specific (`BASE_URL` protocol / `TOP_LVL_DOMAIN`).
 */
export const SESSION_COOKIE = {
    name: SESSION_COOKIE_NAME,
    maxAgeSeconds: SESSION_TTL_SECONDS,
    path: SESSION_COOKIE_PATH,
    sameSite: SESSION_COOKIE_SAME_SITE,
    httpOnly: true
} as const;

export const CSRF_COOKIE = {
    name: CSRF_COOKIE_NAME,
    maxAgeSeconds: SESSION_TTL_SECONDS,
    path: SESSION_COOKIE_PATH,
    sameSite: SESSION_COOKIE_SAME_SITE,
    httpOnly: false
} as const;
